// extracted by mini-css-extract-plugin
export default {"App":"App_App__SkfJj","App-logo":"App_App-logo__C5UU7","App-logo-spin":"App_App-logo-spin__d8Tjd","App-header":"App_App-header__7oWzH","App-link":"App_App-link__9xPj5"};